import { Flex, IconButton, Image } from '@chakra-ui/react'
import UserProfile from './UserProfile'
import { FiMenu } from 'react-icons/fi'

export default function Header({ onOpen, user, ...rest }) {
  return (
    <Flex
      px='4'
      position='sticky'
      top='0'
      height='80px'
      zIndex='1'
      alignItems='center'
      bg='brand'
      boxShadow='0px 7px 12px rgba(0, 0, 0, 0.05);'
      justifyContent={{ base: 'space-between' }}
      {...rest}
    >
      <IconButton
        display={{ base: 'flex', md: 'none' }}
        onClick={onOpen}
        variant='outline'
        aria-label='open menu'
        icon={<FiMenu />}
      />
      <Image ml={{ base: 0, md: 2 }} height='50px' src='/Logo.png'></Image>

      <UserProfile user={user} />
    </Flex>
  )
}
